import { Button, Checkbox, Form, FormField, Modal, Popover, RadioGroup, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setIdUser, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiInformationSlabCircleOutline, mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import { format } from 'date-fns';
import Copy from '../../../../../components/Copy';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import Favorites from '../../../../../components/extras/Favorites';
import Spacer from '../../../../../components/extras/Spacer';
import MPModal from '../../../../../components/MPModal';
import SelectPaging from '../../../../../components/selects/selectPaging';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { BankItems, btnDanger, btnIconForm, btnWarn } from '../../../../../resources/types';



export const AdminMovementsBankPage = () => {
    //const storeAdmin = useStoreAdmin();

    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();


    const [accountPlans, setAccountPlans] = useState<ItemAccountPlan[]>([]);
    const [banks, setBanks] = useState<BankItems[]>([]);
    const [banksFiltered, setBanksFiltered] = useState<BankItems[]>([]);
    const [bank, setBank] = useState<BankItems>();


    const [showAction, setShowAction] = useState(false);
    const [onlyPendings, setOnlyPendings] = useState(false);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const [bankAction, setBankAction] = useState("");




    type ItemAccountPlan = {
        idAccountPlan: number;
        accountPlan: string;
        value: string;
        label: string;
    };
    type ItemConecpt = {
        value: string;
        label: string;
    };

    type ChargesItem = {
        idCharge: number,
        ammount: number,
        currency: string,
        charge: string,
        accountPlan: string,
    };
    type GroupsItems = {
        idGroup: number,
        group: string,
    };
    const conceptItems: ItemConecpt[] = [
        { label: "DEPÓSITO DIRECTO", value: "DEPÓSITO DIRECTO" },
        { label: "TRANSFERENCIA ELECTRÓNICA", value: "TRANSFERENCIA ELECTRÓNICA" },
        { label: "CHEQUE", value: "CHEQUE" },
        { label: "TRANSBANK DEBITO", value: "TRANSBANK DEBITO" },
        { label: "TRANSBANK CREDITO", value: "TRANSBANK CREDITO" },
        { label: "EFECTIVO CLP", value: "EFECTIVO CLP" },
        { label: "EFECTIVO USD", value: "EFECTIVO USD" },
        { label: "EFECTIVO EUR", value: "EFECTIVO EUR" },
        { label: "OTRO", value: "" }
    ]
    useEffect(() => {
        if (data.accountPlans) {
            const mappedAccountPlans: ItemAccountPlan[] = data.accountPlans.map((plan: ItemAccountPlan) => ({
                idAccountPlan: plan.idAccountPlan,
                accountPlan: plan.accountPlan,
                value: plan.idAccountPlan.toString(),
                label: plan.accountPlan
            }));
            setAccountPlans(mappedAccountPlans);
        }
    }, []);

    useEffect(() => {
        handleRefreshMovements();
    }, [parameters.period]); //parameters.startDate, parameters.endDate, 

    useEffect(() => {
        if (banks) {
            if (onlyPendings) {
                setBanksFiltered(banks.filter(bank => bank.idMovement === 0))
            } else {
                setBanksFiltered(banks)
            }

        }

    }, [onlyPendings, banks]);


    const filtered: BankItems[] = banksFiltered.filter((item) => {
        const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
        const text = [item.displayName, item.RUT, item.cuenta, item.remitente, item.glosa, item.banco, item.status].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
        return searchWords.every((word) => text.includes(word.toLocaleLowerCase().replace(/[^a-z0-9]/g, "")));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    const handleAssingMovement = async (idMovementBank: number, idUser: number) => {

        //if (parameters.startDate && parameters.endDate) {

        try {
            setLoading(true)

            let body = {
                month: parameters.period.split("-")[1],
                year: parameters.period.split("-")[0],
                orderBy: "fechaMovimiento",
                order: "desc",
                orderBy2: "idMovementBank",
                order2: "desc",
                idUser: idUser,
                idMovementBank: bank?.idMovementBank
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/banks/assign',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(body),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                setBanks(data.bank);
                setBank(undefined)
                setIdUser(0)
                addNotification(data.status, 'info', setData);
            } else {
                addNotification(data.status, 'error', setData);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, 'error', setData);
        } finally { setLoading(false) }

    }
    const handleRefreshMovements = async () => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.period) {

            try {
                setLoading(true)

                let body = {
                    month: parameters.period.split("-")[1],
                    year: parameters.period.split("-")[0],
                    orderBy: "fechaMovimiento",
                    order: "desc",
                    orderBy2: "idMovementBank",
                    order2: "desc",
                }
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/banks/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify(body),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0 && data.bank) {
                    setBanks(data.bank);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    return (
        <CustomAppLayout
            toolsHide

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    {bank && (
                        <Modal size="small" visible={!!bank}
                            header={<Header description={<>Seleccione una <em>acción</em> entre <strong>asignar</strong> o <strong>descartar</strong>. La opción de asignar se activa una vez seleccionado el usuario</>}>
                                Modificar transferencia
                            </Header>}
                            onDismiss={() => setBank(undefined)}

                            footer={
                                <Form header={null}
                                    secondaryActions={<Button variant="link" onClick={() => setBank(undefined)}>Cancelar</Button>}
                                    actions={
                                        <Button disabled={bankAction === "" || (bankAction == "ASSIGN" && idUser === 0)}
                                            style={{ root: bankAction === "DISCARD" ? btnDanger : btnWarn }}
                                            onClick={() =>
                                                handleAssingMovement(bank.idMovementBank, bankAction === "DISCARD" ? 0 : idUser)
                                            }>
                                            {bankAction === "DISCARD" ? "Descartar" : "Asignar"}
                                        </Button>}

                                />

                            }>
                            <SpaceBetween direction="vertical" size="xs">
                                <RadioGroup value={bankAction}
                                    onChange={(e) => {
                                        setBankAction(e.detail.value)
                                        if (e.detail.value = "DESCARD") setIdUser(0)
                                    }}
                                    items={[
                                        { label: "Asignar", value: "ASSIGN" },
                                        { label: "Descartar", value: "DISCARD" },
                                    ]}

                                />
                                <Spacer height={10} />
                                {bankAction === "ASSIGN" && (
                                    <>
                                        <SelectUser onConfirm={(user) => {
                                            if (user)
                                                setIdUser(user?.idUser)
                                            else
                                                setIdUser(0);
                                        }}
                                        />
                                        <Spacer height={30} />
                                    </>
                                )}
                            </SpaceBetween>

                        </Modal>
                    )
                    }
                    <SpaceBetween direction="vertical" size="xs">

                        <Header

                            //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}

                            actions={
                                <SpaceBetween direction="horizontal" size="xs">

                                    <Favorites />
                                </SpaceBetween>
                            }
                        /*info={<Link variant="info">Info</Link>}*/
                        >
                            Depóstios/Transferencias bancarias



                        </Header>


                        {parameters.month !== '' && parameters.year !== '' && (
                            <Table
                                stickyHeader
                                filter={

                                    <SpaceBetween direction="vertical" size="xs">
                                        <SpaceBetween direction="horizontal" size="xs">

                                            <TextFilter

                                                filteringPlaceholder="Filtrar"
                                                filteringText={filterValue}
                                                onChange={({ detail }) => {
                                                    setFilterValue(detail.filteringText);
                                                    setCurrentPageIndex(1);
                                                }}
                                            />
                                            <div style={{ width: 130 }}>
                                                <MPModal
                                                    width={120}
                                                    today prevMonth nextMonth
                                                    end={new Date()}
                                                    date={`${parameters.period}`}
                                                    onConfirm={(date) => {
                                                        setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                                    }}
                                                />
                                            </div>

                                            {parameters.month && (<Button style={{ root: btnIconForm }} onClick={handleRefreshMovements} ><Icon path={mdiRefresh} size={1} /></Button>)}

                                        </SpaceBetween>
                                        <Checkbox checked={onlyPendings} onChange={(detail) => {
                                            setCurrentPageIndex(1);
                                            setOnlyPendings(detail.detail.checked)
                                        }
                                        }>Solo pendientes</Checkbox>
                                    </SpaceBetween>
                                }
                                pagination={

                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                        {filtered.length > parameters.pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )}

                                        {banks.length > 0 && banks.length > parameters.pageSize && (

                                            <SelectPaging onSelect={(pageSize) => {
                                                setCurrentPageIndex(1);
                                                setParameters({ ...parameters, pageSize: pageSize });
                                            }} />
                                        )}
                                    </SpaceBetween>
                                }
                                variant="embedded"
                                columnDefinitions={[
                                    {
                                        id: "charge",
                                        header: "Fecha",
                                        width: 120,
                                        cell: item => <>{item.fechaMovimiento} <Popover fixedWidth header='Detalle' size="medium"
                                            content={
                                                <SpaceBetween direction="vertical" size="xs">
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        <FormField label="Fecha">
                                                            {format(new Date(item.dateCreated ?? ""), 'dd-MM-yyyy')}
                                                        </FormField>
                                                        <FormField label="Hora">
                                                            {format(new Date(item.dateCreated ?? ""), 'HH:mm')}
                                                        </FormField>
                                                        <FormField label="Transferencia">
                                                            {item.jsonBank?.transfer_id ?? ""}
                                                        </FormField>
                                                    </SpaceBetween>
                                                    <SpaceBetween direction="horizontal" size="xs">
                                                        <FormField label="Documento">
                                                            {item.jsonBank?.document_number ?? ""}
                                                        </FormField>
                                                        <FormField label="Identificador">
                                                            {item.jsonBank?.id ?? ""}
                                                        </FormField>
                                                    </SpaceBetween>
                                                </SpaceBetween>}
                                        ><Icon path={mdiInformationSlabCircleOutline} size={0.75} /></Popover></>,
                                    },
                                    {
                                        id: "data",
                                        header: "Glosa",
                                        cell: item => (

                                            <FormField
                                                description={item.remitente}
                                                label={item.glosa}
                                            />
                                        )
                                    },
                                    {
                                        id: "bank",
                                        header: "Banco",
                                        cell: item =>
                                            item.cuenta !== "" && item.banco !== '' && (

                                                <FormField
                                                    description={`Cuenta ${item.cuenta}`}
                                                    label={item.banco}
                                                />
                                            )

                                    },
                                    {
                                        id: "ammount",
                                        header: "Monto",
                                        cell: item => <Box textAlign='right'>{item.monto.toLocaleString('es-CL', {
                                            style: 'currency',
                                            currency: 'CLP',
                                            maximumFractionDigits: 0
                                        })}</Box>,

                                    },
                                    {
                                        id: "status",
                                        header: "Estado",
                                        cell: item => {
                                            if (item.idMovement > 0) {
                                                return <Popover
                                                    triggerType="custom"
                                                    content={<>Conciliado contra movimiento #{item.idMovement}<br /> <Copy value={item.idMovement.toString()} /></>} header={`Conciliación`}><BadgeCustom color="green">Conciliado</BadgeCustom></Popover>
                                            } else if (item.idMovement < 0) {
                                                return <BadgeCustom
                                                    color="light">Descartado</BadgeCustom>
                                            } else {
                                                return <BadgeCustom
                                                    onClick={() => {
                                                        if (item && item.idMovement === 0) {
                                                            setBank(item);
                                                            setIdUser(0)
                                                            setBankAction("")
                                                            setShowAction(true)
                                                        }
                                                    }} color="yellow">Pendiente</BadgeCustom>

                                            }
                                        },

                                    },
                                ]}
                                trackBy="idMovementBank"
                                items={paginated ?? []}
                                empty={
                                    <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                    >
                                        <SpaceBetween size="m">
                                            <b>Sin movimientos bancarios</b>
                                        </SpaceBetween>
                                    </Box>
                                }
                            />
                        )}
                    </SpaceBetween>
                </>
            }
        />
    );
};